import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(4),
	},
	container: {
		padding: theme.spacing(2),
	}
}));

const Settings = () => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<Container className={classes.container} maxWidth="md">
				<Typography variant="h6">
					Ajustes Generales
				</Typography>
			</Container>
		</div>
	);
};

export default Settings;
